<template>
  <CdrBreadcrumb
    ref="breadcrumbs"
    :truncation-enabled="false"
    :items="breadcrumbs"
    data-ui="breadcrumbs"
  />
</template>

<script>
import { CdrBreadcrumb } from '@rei/cedar';
import metrics from '../mixins/metrics';

export default {
  name: 'BreadcrumbsComponent',
  components: {
    CdrBreadcrumb,
  },
  mixins: [metrics],
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const { breadcrumbs: nodeList } = this.$refs;
      const breadcrumbs = Array.from(nodeList.$el.querySelectorAll('a')) || [];
      breadcrumbs.forEach((crumb) => crumb.addEventListener('click', this.handleClick));
    });
  },
  beforeUnmount() {
    const breadcrumbs = Array.from(this.$refs.breadcrumbs.querySelectorAll('a')) || [];
    breadcrumbs.forEach((crumb) => crumb.removeEventListener('click', this.handleClick));
  },
  methods: {
    handleClick({ target }) {
      const linkName = `{{ pageName }}_breadcrumb_${target.innerText}`;
      this.metricsClick({ linkName });
    },
  },
};
</script>
